
export enum ChangeType {
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3
}

export class ChangeTracked<T> {
    changeType: ChangeType;
    private _originalItem: T = null;

    constructor (obj: T) {
        this._originalItem = obj;
        this.changeType = ChangeType.Unchanged;
    }

    construct(obj: T){
        this._originalItem = obj;
        this.changeType = ChangeType.Unchanged;
    }

    getOriginalData (): T { return this._originalItem; }

    revert (): void {
        if (Array.isArray(this._originalItem)) {
            (<any>this).splice(0);

            this._originalItem.forEach((val, i) => {
                if (val === Object(val)) {
                    (<any>this)[i] = TrackChanges(val);
                } else {
                    (<any>this)[i] = val;
                }
            });
        } else {
            for (const id in this._originalItem) {
                const val = this._originalItem[id];
                if (val === Object(val)) {
                    (<any>this)[id] = TrackChanges(val);
                } else {
                    (<any>this)[id] = val;
                }
            }
        }
        this.changeType = ChangeType.Unchanged;
    }

    isChanged (deep: boolean = false): boolean {
        let changed: boolean = this.changeType !== ChangeType.Unchanged;
        if (deep) {
            if (Array.isArray(this)) {
                const arr: any[] = this;
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i] && (<any>arr[i]).isChanged !== undefined) {
                        changed = changed || (<any>arr[i]).isChanged(deep);
                    }
                }
            } else {
                const obj: any = this;
                for (const id in obj) {
                    if (obj[id] && (<any>obj[id]).isChanged !== undefined) {
                        changed = changed || (<any>obj[id]).isChanged(deep);
                    }
                }
            }
        }
        return changed;
    }
}

export function TrackChanges<T> (obj: T): T & ChangeTracked<T> {
    //reset all the mixed in stuff
    const ctObj = <any>obj;
    delete ctObj.changeType;
    delete ctObj.getOriginalData;
    delete ctObj.isChanged;
    delete ctObj.revert;
    delete ctObj._originalItem;
    obj = ctObj;

    if (Array.isArray(obj)) {
        const newArr = <T & ChangeTracked<T> & any[]>obj.slice();
        newArr.construct = ChangeTracked.prototype.construct.bind(newArr);
        newArr.construct(obj);
        newArr.isChanged = ChangeTracked.prototype.isChanged.bind(newArr);
        newArr.getOriginalData = ChangeTracked.prototype.getOriginalData.bind(newArr);
        newArr.revert = ChangeTracked.prototype.revert.bind(newArr);
        for (let i = 0; i < newArr.length; i++) {
            if (newArr[i] === Object(newArr[i])) {
                newArr[i] = TrackChanges(newArr[i]);
            }
        }
        return newArr;
    } else {
        const newObj = <T & ChangeTracked<T>>Object.assign({}, obj);
        newObj.construct = ChangeTracked.prototype.construct.bind(newObj);
        newObj.construct(obj);
        newObj.isChanged = ChangeTracked.prototype.isChanged.bind(newObj);
        newObj.getOriginalData = ChangeTracked.prototype.getOriginalData.bind(newObj);
        newObj.revert = ChangeTracked.prototype.revert.bind(newObj);
        for (const id in obj) {
            const val = (<any>obj)[id];
            if (val === Object(val)) {
                (<any>newObj)[id] = TrackChanges(val);
            }
        }
        return newObj;
    }
}
